export function registerComponent(name, component) {
    document.addEventListener('alpine:init', () => {
        window.Alpine.data(name, component);
    });
}

export function registerStore(name, store) {
    document.addEventListener('alpine:init', () => {
        if (!window.Alpine.store(name)) {
            window.Alpine.store(name, store);
        }
    });
}

export function registerDirective(name, directive) {
    document.addEventListener('alpine:init', () => {
        window.Alpine.directive(name, directive);
    });
}
